/**
 * @generated SignedSource<<58a77597d743bb6743aff2acb32598e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientGoalsCard_goals$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly updatedAt: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ClientGoal_goal">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly totalCount: number;
  readonly " $fragmentSpreads": FragmentRefs<"ClientGoalsDrawer_goals">;
  readonly " $fragmentType": "ClientGoalsCard_goals";
};
export type ClientGoalsCard_goals$key = {
  readonly " $data"?: ClientGoalsCard_goals$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientGoalsCard_goals">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientGoalsCard_goals",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientGoalEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientGoal",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "format",
                  "value": "MMM DD, YYYY"
                }
              ],
              "kind": "ScalarField",
              "name": "updatedAt",
              "storageKey": "updatedAt(format:\"MMM DD, YYYY\")"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClientGoal_goal"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClientGoalsDrawer_goals"
    }
  ],
  "type": "ClientGoalConnection",
  "abstractKey": null
};

(node as any).hash = "7f0d2465e1e14cd4bf2ad9af4bae7d92";

export default node;
